<template>
    <div>
        <!-- <van-nav-bar  title="投票签名" left-text="取消签名" left-arrow @click-left="closeDialog" :fixed="true"
            :placeholder="true" class="nav-bar" /> -->
        <div class="canvaspanel">
            <div class="canvasborder">
                <!-- 签名区 -->
                <vue-esign ref="esign" class="father" :width="350" :height="400" :isCrop="isCrop" :lineWidth="lineWidth"
                    :lineColor="lineColor" :bgColor.sync="bgColor">


                </vue-esign>
                <div @click="handleClear" class="clear">清除</div>
                <!-- <p v-if="showText" class="text">签字区</p> -->
            </div>

            <div class="buttongroup">
                <div @click="handleReset" class="empty">取消</div>
                <div @click="handleGenerate" class="autograph">确定</div>
            </div>
             
        </div>
        <img :src="resultImg" alt="" v-show="false">

    </div>
</template>
<script>
import api from '@/api/public.js'
import { Toast } from 'vant';
export default {
    name: "esign",
    components: {

    },
    data() {
        return {
            title: '手写签名',
            lineWidth: 5,
            lineColor: '#000000',
            bgColor: '',
            resultImg: '',
            isCrop: false,
            signUrl: '',
            showText: true
        }
    },
    created() {
    },

    methods: {
        handleReset() {
            this.$refs.esign.reset()
            this.$emit("close", this.resultImg, false);
        },
        handleClear() {
            this.$refs.esign.reset()
        },
        handleGenerate() {

            this.$refs.esign.generate().then(res => {
                this.resultImg = res;
                this.$emit("close", this.resultImg, false);
                this.dataURLtoBlob(this.resultImg)



            }).catch(err => {
                return Toast.fail('请签名');
                //alert(err) // 画布没有签字时会执行这里 'Not Signned'
            })


        },
        closeDialog() {
            this.resultImg = '';
            this.$emit("close", this.resultImg, false
            );
            this.handleReset()
        },
        // base64转化为Blob对象
        dataURLtoBlob(imageEditorBase64) {
            var base64Arr = imageEditorBase64.split(",");
            var imgtype = "";
            var base64String = "";
            if (base64Arr.length > 1) {
                //如果是图片base64，去掉头信息
                base64String = base64Arr[1];
                imgtype = base64Arr[0].substring(
                    base64Arr[0].indexOf(":") + 1,
                    base64Arr[0].indexOf(";")
                );
            }
            // 将base64解码
            var bytes = atob(base64String);
            //var bytes = base64;
            var bytesCode = new ArrayBuffer(bytes.length);
            // 转换为类型化数组
            var byteArray = new Uint8Array(bytesCode);

            // 将base64转换为ascii码
            for (var i = 0; i < bytes.length; i++) {
                byteArray[i] = bytes.charCodeAt(i);
            }

            // 生成Blob对象（文件对象）
            let file = new Blob([bytesCode], { type: imgtype });
            let fd = new FormData();
            fd.append("file", file);
            api.uploadfile(fd).then(res => {
                if (res.data.code == 200) {
                    this.$emit('success', res.data.data.url)
                }
            })
        },
    },
    watch: {
        // resultImg(val) {
        //     console.log('====', this.resultImg)
        //     if (val != '') {
        //         this.showText = false
        //     } else {
        //         this.showText = true

        //     }
        // }
    }

}
</script>
<style  lang="less" scoped>
.canvasborder {
    position: relative;
    width: 90%;
    height: 90%;
    margin: 20px auto;
    border: dashed 1px #ccc;
    background: #F4F7F9;

    .clear {
        position: absolute;
        top: 20px;
        right: 20px;
        color: #4985FF;
    }

    .text {
        position: absolute;
        top: 200px;
        right: 50%;
        font-size: 36px;
        color: #E9E9E9;
        z-index: 99;
        transform: translateX(50%) translateY(-70px)
    }
}




.buttongroup {
    display: flex;
    justify-content: center;
}

.empty {

    width: 170px;
    height: 44px;
    background: #BABABA;
    text-align: center;
    line-height: 44px;
    border-radius: 53px 53px 53px 53px;

    color: #FFFFFF;
}

.autograph {
    width: 170px;
    height: 44px;
    background: #BABABA;
    text-align: center;
    line-height: 44px;
    border-radius: 53px 53px 53px 53px;
    margin-left: 20px;
    color: #FFFFFF;
    background: linear-gradient(133deg, #FF6C19 0%, #FFA370 100%);
}

// @media screen and (orientation: portrait) {

//     /* 竖屏 */
//     .canvaspanel canvas {
//         width: 100% !important;
//         height: 100% !important;
//     }

//     .buttongroup {
//         left: -50px;
//         position: absolute;
//         bottom: 100px;
//         transform: rotate(90deg);
//     }

//     .van-toast--fail {
//         transform: rotate(90deg);
//     }

//     .empty,
//     .autograph {
//         width: 100px;
//         height: 40px;
//         line-height: 40px;
//         font-size: 1rem;
//         float: left;
//         color: white;
//         text-align: center;
//     }

//     .empty {
//         background: #ccc;
//     }

//     .autograph {
//         background: #178ef0;
//     }
// }

// @media screen and (orientation: landscape) {

//     /* 横屏 */
//     .buttongroup {
//         right: 30px;
//         position: absolute;
//         bottom: 20px;
//         transform: rotate(0deg);
//     }

//     .empty,
//     .autograph {
//         width: 100px;
//         height: 40px;
//         line-height: 40px;
//         font-size: 1rem;
//         float: left;
//         color: white;
//         text-align: center;
//     }

//     .empty {
//         background: #ccc;
//     }

//     .autograph {
//         background: #178ef0;
//     }
// }
</style>